const locale = {
    placeholder: 'Hora',
    rangePlaceholder: ['Hora de início', 'Hora de término'],
};
export default locale;
